import { render, staticRenderFns } from "./im-image-message.vue?vue&type=template&id=4f51df56&scoped=true"
import script from "./im-image-message.vue?vue&type=script&lang=js"
export * from "./im-image-message.vue?vue&type=script&lang=js"
import style0 from "./im-image-message.vue?vue&type=style&index=0&id=4f51df56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f51df56",
  null
  
)

export default component.exports